import * as React from 'react'

import { DeprecatedText } from '@syconium/little-miss-figgy'

import { GalleryImageStateContainer } from '../contexts/GalleryImageStateContainer'

import { IProps } from './IProps'
import { Container } from './styles'

export const GalleryImagePaginationText: React.FC<IProps> = () => {
  const { allAssets, currentAssetIndex } = GalleryImageStateContainer.useContainer()

  const currentIndex = Math.min(Math.max(currentAssetIndex, 0), allAssets.length - 1)

  return (
    <Container>
      <DeprecatedText textType='h2'>
        {currentIndex + 1}/{allAssets.length}
      </DeprecatedText>
    </Container>
  )
}
